import React from 'react';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { Modal, Form, Button, Typography, Divider } from 'antd';
import rootApi from '@utils/baseAPI/WrapperApi';
import { showError, showSuccess } from '@components/notification';
import CustomerSelect from '@components/Select/SelectCustomer';

const { Title } = Typography;

const DialogBindOwner = (props) => {
  const { depot, open, setOpen, refetch } = props;

  const { mutateAsync, isLoading } = useMutation(['bind-users'], (data) => {
    const user_ids = data.user_ids.map((item) => item?.value);
    return rootApi.post(`/depot-users/bind`, {
      depot_code: depot?.depot_code,
      user_ids: user_ids
    });
  });

  const formik = useFormik({
    initialValues: {
      user_ids: []
    },
    onSubmit: (values) => {
      mutateAsync(values)
        .then(() => {
          handleClose();
          showSuccess({ message: 'Gắn khách hàng trạm thành công' });
        })
        .catch((error) => {
          showError(error || 'Vui lòng liên hệ admin để được hỗ trợ');
        });
    }
  });

  const handleClose = () => {
    formik.resetForm();
    refetch();
    setOpen(false);
  };

  // Custom footer for the modal
  const modalFooter = (
    <>
      <Button onClick={handleClose} style={{ height: '36px' }}>
        Hủy
      </Button>
      <Button
        type="primary"
        htmlType="submit"
        form="bind-owner-form" // Link button to form submission
        style={{ height: '36px', backgroundColor: '#2D9764' }}
        loading={isLoading}>
        Gán khách hàng
      </Button>
    </>
  );

  return (
    <Modal
      title="Gán khách hàng vào trạm sạc"
      visible={open}
      onCancel={handleClose}
      footer={modalFooter} // Set the custom footer
      width={600}>
      <Divider />
      <Form id="bind-owner-form" onFinish={formik.handleSubmit} layout="vertical">
        <Form.Item
          name="user_ids"
          rules={[{ required: true, message: 'Vui lòng chọn khách hàng' }]}>
          <CustomerSelect
            onChange={(value, option) => {
              formik.setFieldValue('user_ids', value);
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DialogBindOwner;
